import { render, staticRenderFns } from "./CardOverlay.vue?vue&type=template&id=b6b008aa&scoped=true&"
import script from "./CardOverlay.vue?vue&type=script&lang=js&"
export * from "./CardOverlay.vue?vue&type=script&lang=js&"
import style0 from "./CardOverlay.vue?vue&type=style&index=0&id=b6b008aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b008aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
